/* eslint-disable import/no-cycle */
/* eslint-disable camelcase */
import {
	clearItems,
	requestItems,
	receiveItems,
	setTotalCount,
	setLoadItemsErrorMessage,
	clearLoadItemsErrorMessage
} from './actions';

// ************
// PARTS
// ************
const reducerParts = {
	[clearItems]: state => {
		return {
			...state,
			items: [],
			totalCount: undefined,
			isLoadingItems: false,
			isLoadedItems: false,
			loadItemsErrorMessage: undefined
		};
	},
	[requestItems]: state => {
		return {
			...state,
			isLoadingItems: true,
			loadItemsErrorMessage: undefined
		};
	},
	[receiveItems]: (state, { payload: { items } }) => {
		return {
			...state,
			items: [...state.items, ...items],
			isLoadingItems: false,
			isLoadedItems: true
		};
	},
	[setTotalCount]: (state, { payload: { totalCount } }) => {
		return {
			...state,
			totalCount
		};
	},
	[setLoadItemsErrorMessage]: (state, { payload: { message } }) => {
		return {
			...state,
			isLoadingItems: false,
			loadItemsErrorMessage: message
		};
	},
	[clearLoadItemsErrorMessage]: state => {
		return {
			...state,
			loadItemsErrorMessage: undefined
		};
	}
};

export default reducerParts;
